import { render, staticRenderFns } from "./tenderingfrm4.vue?vue&type=template&id=35e96ac8"
import script from "./tenderingfrm4.vue?vue&type=script&lang=js"
export * from "./tenderingfrm4.vue?vue&type=script&lang=js"
import style0 from "./tenderingfrm4.vue?vue&type=style&index=0&id=35e96ac8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports